const getters = {
  agora_appid: (state) => state.agora.agora_appid,

  employee_full_status: (state) => state.employee_full_status,
  employee_permissions: (state) => state.employee_permissions,
  employee_camera_status: (state) => state.employee_camera_status,
  employee_teacherMikeStatus: (state) => state.employee_teacherMikeStatus,
  employee_teacherCameraStatus: (state) => state.employee_teacherCameraStatus,
  employee_studentMikeStatus: (state) => state.employee_studentMikeStatus,
  employee_studentCameraStatus: (state) => state.employee_studentCameraStatus,

  observation_full_status: (state) => state.observation_full_status,
  observation_permissions: (state) => state.observation_permissions,
  observation_teacherMikeStatus: (state) => state.observation_teacherMikeStatus,
  observation_teacherCameraStatus: (state) =>
    state.observation_teacherCameraStatus,
  observation_studentMikeStatus: (state) => state.observation_studentMikeStatus,
  observation_studentCameraStatus: (state) =>
    state.observation_studentCameraStatus,

  student_full_status: (state) => state.student_full_status,
  student_permissions: (state) => state.student_permissions,
  student_drawing_permissions: (state) => state.student_drawing_permissions,
  student_teacherMikeStatus: (state) => state.student_teacherMikeStatus,
  student_teacherCameraStatus: (state) => state.student_teacherCameraStatus,

  teacher_full_status: (state) => state.teacher_full_status,
  teacher_permissions: (state) => state.teacher_permissions,
  teacher_studentMikeStatus: (state) => state.teacher_studentMikeStatus,
  teacher_studentCameraStatus: (state) => state.teacher_studentCameraStatus,
  teacher_start_class: (state) => state.teacher_start_class,

  classRoomKey: (state) => state.classRoomKey,
  liveChats: (state) => state.liveChats,
  onlineUsers: (state) => state.onlineUsers,
  HiTutorToken: (state) => state.HiTutorToken,
  teacher: (state) => state.teacher,

  classTime: (state) => state.classTime,

  classRoomId: (state) => state.classRoomId,
  room: (state) => state.room,
  connected: (state) => state.connected,

  MaterialMediaObject: (state) => state.MaterialMediaObject,
  MaterialVedioObject: (state) => state.MaterialVedioObject,
  MaterialObject: (state) => state.MaterialObject,
  MaterialObjectFrom3000: (state) => state.MaterialObjectFrom3000,
  ClassroomMaterial: (state) => state.ClassroomMaterial,

  TeacherName: (state) => state.TeacherName,
  UserId: (state) => state.UserId,
  UserName: (state) => state.UserName,
  UserType: (state) => state.UserType,
  hituteIdentifier: (state) => state.hituteIdentifier,

  fabricsData: (state) => state.fabricsData,
  dynamicCounterMediaFileUrl: (state) => state.dynamicCounterMediaFileUrl,
  dataGetMaterialByFileUrl: (state) => state.dataGetMaterialByFileUrl,

  currentUserCasalomaRegistered: (state) => state.currentUserCasalomaRegistered,
  currentUserCasalomaAccessToken: (state) =>
    state.currentUserCasalomaAccessToken,
  currentResponseIMCasaloma: (state) => state.currentResponseIMCasaloma,
  casalomaRoomName: (state) => state.casalomaRoomName,
  checkCasalomaRoomNameAvailability: (state) =>
    state.checkCasalomaRoomNameAvailability,

  user: (state) => state.user,
  jwtToken: (state) => state.jwtToken,
  isLoggedIn: (state) => state.isLoggedIn,
  currentlyViewingClass: (state) => state.currentlyViewingClass,
  IMCasalomaClassAvailability: (state) => state.IMCasalomaClassAvailability,
  IMCasalomaUserAvailability: (state) => state.IMCasalomaUserAvailability,
  IMCasalomaUserLogin: (state) => state.IMCasalomaUserLogin,
  IMCasalomaUserRegister: (state) => state.IMCasalomaUserRegister,
  IMCasalomaUserClass: (state) => state.IMCasalomaUserClass,

  IMCasalomaFetchChats: (state) => state.IMCasalomaFetchChats,
  BeginTimeStamp: (state) => state.BeginTimeStamp,
  EndTimeStamp: (state) => state.EndTimeStamp,

  checkInState: (state) => state.checkInState,
  checkOutState: (state) => state.checkOutState,

  LessonRecordUrlStore: (state) => state.LessonRecordUrlStore,
  TBUrlStore: (state) => state.TBUrlStore,
  LessonRecordQuery: (state) => state.LessonRecordQuery,

  ClassroomMessage: (state) => state.ClassroomMessage,
  LiveChatChannel: (state) => state.LiveChatChannel,

  errorLogs: (state) => state.errorLogs,
};
export default getters;
